// extracted by mini-css-extract-plugin
export var card = "_ni-1";
export var summary = "_ni-0";
export var unreadDot = "_ni-2";